import React from "react"
import PropTypes from "prop-types"
import { Box, Typography } from "@material-ui/core"

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
}

function TabPanel(props) {
	const { children, value, index, ...other } = props

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`additional-details-tabpanel-${index}`}
			aria-labelledby={`additional-details-tab-${index}`}
			{...other}
		>
			{value === index && <Box style={{ padding: "20px 12px", position: "relative", width: "100%" }}>{children}</Box>}
		</div>
	)
}

export default TabPanel
